export default __webpack_public_path__ + "static/media/check.2bf0d053.svg";